import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui/ui.module';
import { ReviewsModule } from '../../../reviews/reviews.module';
import { UserProfilePractitionerInformationModule } from '../../../user-profile/user-profile-resume/user-profile-practitioner-information/user-profile-practitioner-information.module';
import { UserAboutComponent } from './user-about/user-about.component';
import { UserContentComponent } from './user-content/user-content.component';
import { UserDescriptionComponent } from './user-description/user-description.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserDetailModule } from './user-detail/user-detail.module';
import { UserExamsComponent } from './user-exams/user-exams.component';
import { UserOverviewComponent } from './user-overview/user-overview.component';
import { UserPortfolioModule } from './user-portfolio/user-portfolio.module';
import { UserReputationComponent } from './user-reputation/user-reputation.component';
import { UserReviewsComponent } from './user-reviews/user-reviews.component';
import { UserSkillsComponent } from './user-skills/user-skills.component';
import { UserVerificationsComponent } from './user-verifications/user-verifications.component';

@NgModule({
  imports: [
    CommonModule,
    FeatureFlagsModule,
    PipesModule,
    ReviewsModule,
    TrackingModule,
    UiModule,
    UserDetailModule,
    UserPortfolioModule,
    UserProfilePractitionerInformationModule,
  ],
  declarations: [
    UserAboutComponent,
    UserContentComponent,
    UserDescriptionComponent,
    UserExamsComponent,
    UserOverviewComponent,
    UserReputationComponent,
    UserReviewsComponent,
    UserSkillsComponent,
    UserVerificationsComponent,
  ],
  exports: [
    UserDetailComponent,
    UserContentComponent,
    UserReputationComponent,
    UserExamsComponent,
  ],
})
export class UserProfileInformationModule {}
